import React from "react";
const Q1 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What is the Eligibility?</div>
        <p>
          The T-Shirt Giveaway is open to legal residents of India, who sign up
          at www.bunk4study.com. Entrants must be 13 as of their date of entry
          in this promotion in order to qualify. Giveaway is subject to federal,
          state, and local laws and regulations and void where prohibited by
          law. Bunk4Study's employees, its subsidiaries,affiliates, suppliers,
          partners, advertising and promotion agencies,and directors
          (collectively the “Employees”), as well as members of an Employees'
          immediate family and/or those living in the same household of
          Employees are ineligible to participate in the T-ShirtGiveaway.
        </p>
      </div>
    </div>
  );
};

export default Q1;
